/**
 * カテゴリ一覧
 */
export default {
  /**
   * カテゴリ一覧取得(特大カテゴリ指定)
   * @param {Number} type 特大カテゴリ
   * @returns {Array} カテゴリ一覧
   */
  getCategoryTypeList: function (type = 1) {
    const catList = this.getAll(),
      len = catList.length;
    let list = [];
    for (let i = 0; i < len; i++) {
      const cat = catList[i];
      if (cat.catType === type) {
        list.push(cat);
      } else if (cat.catType) {
        // 他のカテゴリ
        continue;
      } else {
        // 未指定
        const childLen = cat.list.length;
        let midList = [];
        for (let j = 0; j < childLen; j++) {
          const mitCat = cat.list[j];
          if (mitCat.catType === type) {
            midList.push(midList);
          }
        }

        if (midList.length > 0) {
          list.push({
            catExlCd: cat.catExlCd,
            catExlNm: cat.catExlNm,
            catLrgCd: cat.catLrgCd,
            catLrgNm: cat.catLrgNm,
            iconType: cat.iconType,
            list: midList
          });
        }
      }
    }
    return list;
  },
  /**
   * カテゴリ全取得
   * @returns {Array} カテゴリ一覧
   */
  getAll: function () {
    return this.CATEGORY;
  },
  CATEGORY: [
    {
      catExlCd: "leisure",
      catExlNm: "遊ぶ",
      catLrgCd: "102",
      catLrgNm: "レジャー",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "遊園地・テーマパーク",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "遊園地・テーマパーク・水族館・動植物園"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "美術館・博物館・アート",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "美術館・博物館・アート"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "果物・味覚狩り",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "果物・味覚狩り"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "キッズ向け",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "キッズ向け"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "アウトドアレジャー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "アウトドアレジャー"
            },
            {
              catSmlCd: "302",
              catSmNm: "ウィンタースポーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "マリンスポーツ"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "その他レジャー施設",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他レジャー施設"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "leisure",
      catExlNm: "遊ぶ",
      catLrgCd: "103",
      catLrgNm: "エンタメ",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "映画",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "映画館"
            },
            {
              catSmlCd: "302",
              catSmNm: "映画作品券"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "アミューズメント",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ボウリング"
            },
            {
              catSmlCd: "302",
              catSmNm: "カラオケ"
            },
            {
              catSmlCd: "303",
              catSmNm: "インターネットカフェ"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "公演・観戦チケット",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スポーツ観戦チケット"
            },
            {
              catSmlCd: "302",
              catSmNm: "演劇・舞台"
            },
            {
              catSmlCd: "303",
              catSmNm: "コンサート"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他チケット"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "動画・音楽配信",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "動画・音楽配信"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "その他エンタメ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他エンタメ"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "gourmet",
      catExlNm: "食べる",
      catLrgCd: "113",
      catLrgNm: "グルメ",
      list: [
        {
          catMidCd: "201",
          catMidNm: "飲食店",
          catType: 2,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "居酒屋"
            },
            {
              catSmlCd: "302",
              catSmNm: "ダイニングバー"
            },
            {
              catSmlCd: "303",
              catSmNm: "ＢＡＲ・ビアガーデン"
            },
            {
              catSmlCd: "304",
              catSmNm: "和食"
            },
            {
              catSmlCd: "305",
              catSmNm: "焼肉・ホルモン"
            },
            {
              catSmlCd: "306",
              catSmNm: "ステーキ・グリル料理"
            },
            {
              catSmlCd: "307",
              catSmNm: "すき焼き・しゃぶしゃぶ"
            },
            {
              catSmlCd: "308",
              catSmNm: "懐石・会席料理"
            },
            {
              catSmlCd: "309",
              catSmNm: "割烹・小料理"
            },
            {
              catSmlCd: "310",
              catSmNm: "魚介・海鮮料理"
            },
            {
              catSmlCd: "311",
              catSmNm: "寿司"
            },
            {
              catSmlCd: "312",
              catSmNm: "天ぷら"
            },
            {
              catSmlCd: "313",
              catSmNm: "鍋"
            },
            {
              catSmlCd: "314",
              catSmNm: "そば・うどん"
            },
            {
              catSmlCd: "315",
              catSmNm: "丼もの"
            },
            {
              catSmlCd: "316",
              catSmNm: "定食・食堂"
            },
            {
              catSmlCd: "317",
              catSmNm: "軽食"
            },
            {
              catSmlCd: "318",
              catSmNm: "洋食"
            },
            {
              catSmlCd: "319",
              catSmNm: "カレー"
            },
            {
              catSmlCd: "320",
              catSmNm: "ピザ"
            },
            {
              catSmlCd: "321",
              catSmNm: "イタリア料理"
            },
            {
              catSmlCd: "322",
              catSmNm: "フランス料理"
            },
            {
              catSmlCd: "323",
              catSmNm: "中国料理"
            },
            {
              catSmlCd: "324",
              catSmNm: "韓国料理"
            },
            {
              catSmlCd: "325",
              catSmNm: "アジア・エスニック"
            },
            {
              catSmlCd: "326",
              catSmNm: "多国籍"
            },
            {
              catSmlCd: "327",
              catSmNm: "ブッフェ・バイキング"
            },
            {
              catSmlCd: "328",
              catSmNm: "ラーメン・つけ麺・ちゃんぽん"
            },
            {
              catSmlCd: "329",
              catSmNm: "自然・薬膳・野菜"
            },
            {
              catSmlCd: "330",
              catSmNm: "カフェ・スイーツ"
            },
            {
              catSmlCd: "331",
              catSmNm: "ファミレス・ファーストフード"
            },
            {
              catSmlCd: "332",
              catSmNm: "エンターテインメント"
            },
            {
              catSmlCd: "333",
              catSmNm: "その他飲食店"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "予約サイト・食事券",
          catType: 1,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "予約サイト・食事券"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "care",
      catExlNm: "育児・介護・健康",
      catLrgCd: "109",
      catLrgNm: "育児",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "育児サービス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "育児用品"
            },
            {
              catSmlCd: "302",
              catSmNm: "その他育児サービス"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "育児補助制度",
          hidden: false,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "育児補助制度"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "託児・ベビーシッター",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "育児施設・学童"
            },
            {
              catSmlCd: "302",
              catSmNm: "ベビーシッター"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "教育・セミナー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "教育"
            },
            {
              catSmlCd: "302",
              catSmNm: "セミナー"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "shopping",
      catExlNm: "買い物",
      catLrgCd: "114",
      catLrgNm: "ショッピング",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "書籍・新聞",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "新聞"
            },
            {
              catSmlCd: "302",
              catSmNm: "書籍・雑誌"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "定期購読",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ビジネス誌"
            },
            {
              catSmlCd: "302",
              catSmNm: "一般誌"
            },
            {
              catSmlCd: "303",
              catSmNm: "スポーツ誌"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "オンラインショップ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ファッション"
            },
            {
              catSmlCd: "302",
              catSmNm: "ビジネススーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "メガネ・コンタクト"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブランド品"
            },
            {
              catSmlCd: "305",
              catSmNm: "スポーツ用品"
            },
            {
              catSmlCd: "306",
              catSmNm: "食料・飲料"
            },
            {
              catSmlCd: "307",
              catSmNm: "美容・コスメ"
            },
            {
              catSmlCd: "308",
              catSmNm: "家具・雑貨"
            },
            {
              catSmlCd: "309",
              catSmNm: "家電・ソフトウェア"
            },
            {
              catSmlCd: "310",
              catSmNm: "カー用品"
            },
            {
              catSmlCd: "311",
              catSmNm: "健康グッズ・食品"
            },
            {
              catSmlCd: "312",
              catSmNm: "オンラインサービス"
            },
            {
              catSmlCd: "313",
              catSmNm: "総合ECサイト"
            },
            {
              catSmlCd: "314",
              catSmNm: "その他オンラインショップ"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "店舗",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ファッション"
            },
            {
              catSmlCd: "302",
              catSmNm: "ビジネススーツ"
            },
            {
              catSmlCd: "303",
              catSmNm: "メガネ・コンタクト"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブランド品"
            },
            {
              catSmlCd: "305",
              catSmNm: "スポーツ用品"
            },
            {
              catSmlCd: "306",
              catSmNm: "食品・飲料"
            },
            {
              catSmlCd: "307",
              catSmNm: "美容・コスメ"
            },
            {
              catSmlCd: "308",
              catSmNm: "家具・雑貨"
            },
            {
              catSmlCd: "309",
              catSmNm: "家電・ソフトウェア"
            },
            {
              catSmlCd: "310",
              catSmNm: "カー用品"
            },
            {
              catSmlCd: "311",
              catSmNm: "健康グッズ・食品"
            },
            {
              catSmlCd: "312",
              catSmNm: "ショッピングモール・デパート"
            },
            {
              catSmlCd: "313",
              catSmNm: "スーパー・ドラッグストア"
            },
            {
              catSmlCd: "314",
              catSmNm: "ホームセンター"
            },
            {
              catSmlCd: "315",
              catSmNm: "その他店舗"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "ギフト",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "カタログギフト"
            },
            {
              catSmlCd: "302",
              catSmNm: "フラワーギフト"
            },
            {
              catSmlCd: "303",
              catSmNm: "商品券"
            },
            {
              catSmlCd: "304",
              catSmNm: "ギフトコード"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他ギフト"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "株主優待券",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "株主優待券"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "leisure",
      catExlNm: "遊ぶ",
      catLrgCd: "105",
      catLrgNm: "日帰り湯",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "日帰り湯・サウナ・岩盤浴",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "日帰り湯"
            },
            {
              catSmlCd: "302",
              catSmNm: "サウナ・岩盤浴"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "others",
      catExlNm: "その他",
      catLrgCd: "106",
      catLrgNm: "リラク・ビューティー",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "リラクサロン",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "リラクサロン"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "エステ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "エステ・スパ"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "ヘア・ネイル・アイサロン",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ヘアサロン"
            },
            {
              catSmlCd: "302",
              catSmNm: "ヘアケア"
            },
            {
              catSmlCd: "303",
              catSmNm: "ネイルサロン"
            },
            {
              catSmlCd: "304",
              catSmNm: "アイサロン"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "予約サイト",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "予約サイト"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "その他リラク・ビューティー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他リラク・ビューティー"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "others",
      catExlNm: "その他",
      catLrgCd: "104",
      catLrgNm: "スポーツ",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "フィットネス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スポーツクラブ・ジム・トレーニング"
            },
            {
              catSmlCd: "302",
              catSmNm: "ヨガ・ピラティス"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "ゴルフ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ゴルフ場"
            },
            {
              catSmlCd: "302",
              catSmNm: "ゴルフスクール"
            },
            {
              catSmlCd: "303",
              catSmNm: "ゴルフ練習場"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "テニス",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "テニス場"
            },
            {
              catSmlCd: "302",
              catSmNm: "テニススクール"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "サッカー・フットサル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "サッカー・フットサル"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "ボルダリング・クライミング",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ボルダリング・クライミング"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "その他スポーツ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他スポーツ"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "travel",
      catExlNm: "旅",
      catLrgCd: "101",
      catLrgNm: "トラベル",
      catType: 3,
      list: [
        {
          catMidCd: "201",
          catMidNm: "国内の宿",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ホテル"
            },
            {
              catSmlCd: "302",
              catSmNm: "旅館"
            },
            {
              catSmlCd: "303",
              catSmNm: "ペンション・プチホテル"
            },
            {
              catSmlCd: "304",
              catSmNm: "貸別荘・コテージ"
            },
            {
              catSmlCd: "305",
              catSmNm: "おもてなしの宿"
            },
            {
              catSmlCd: "306",
              catSmNm: "民宿"
            },
            {
              catSmlCd: "307",
              catSmNm: "カプセルホテル"
            },
            {
              catSmlCd: "308",
              catSmNm: "ゲストハウス・ホステル・ドミトリー"
            },
            {
              catSmlCd: "309",
              catSmNm: "グランピング"
            },
            {
              catSmlCd: "310",
              catSmNm: "その他国内の宿"
            },
            {
              catSmlCd: "311",
              catSmNm: "予約サイト"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "国内の宿（Bene楽天）",
          hidden: true,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ホテル"
            },
            {
              catSmlCd: "302",
              catSmNm: "旅館"
            },
            {
              catSmlCd: "303",
              catSmNm: "ペンション・プチホテル"
            },
            {
              catSmlCd: "304",
              catSmNm: "貸別荘・コテージ"
            },
            {
              catSmlCd: "306",
              catSmNm: "民宿"
            },
            {
              catSmlCd: "307",
              catSmNm: "カプセルホテル"
            },
            {
              catSmlCd: "308",
              catSmNm: "ゲストハウス・ホステル・ドミトリー"
            },
            {
              catSmlCd: "309",
              catSmNm: "グランピング"
            },
            {
              catSmlCd: "310",
              catSmNm: "その他国内の宿"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "公共の宿",
          hidden: true,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "公営国民宿舎"
            },
            {
              catSmlCd: "302",
              catSmNm: "サイクリングターミナル"
            },
            {
              catSmlCd: "303",
              catSmNm: "ＳＥＭＰＯＳ"
            },
            {
              catSmlCd: "304",
              catSmNm: "しがくのやど"
            },
            {
              catSmlCd: "305",
              catSmNm: "公立学校共済組合施設"
            },
            {
              catSmlCd: "306",
              catSmNm: "警察共済組合施設"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "海外旅行",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "海外旅行"
            }
          ]
        },
        // {
        //   catMidCd: "205",
        //   catMidNm: "パッケージツアー・旅行代理店",
        //   list: [
        //     {
        //       catSmlCd: "301",
        //       catSmNm: "パッケージツアー"
        //     },
        //     {
        //       catSmlCd: "302",
        //       catSmNm: "旅行代理店"
        //     }
        //   ]
        // },
        {
          catMidCd: "206",
          catMidNm: "航空券・交通",
          catType: 3,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "航空券"
            },
            {
              catSmlCd: "302",
              catSmNm: "フェリー・クルーズ"
            },
            {
              catSmlCd: "303",
              catSmNm: "バス･タクシー"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他航空券・交通"
            }
          ]
        },
        {
          catMidCd: "207",
          catMidNm: "その他旅行関連",
          catType: 3,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他旅行関連"
            }
          ]
        },
        {
          catMidCd: "201",
          catMidNm: "国内宿泊予約サイト",
          catType: 4,
          list: [
            {
              catSmlCd: "311",
              catSmNm: "国内宿泊予約サイト"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "海外宿泊予約サイト",
          catType: 4,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "海外宿泊予約サイト"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "others",
      catExlNm: "その他",
      catLrgCd: "116",
      catLrgNm: "オリジナル企画",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "慶事お祝い",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚・出産"
            },
            {
              catSmlCd: "302",
              catSmNm: "仕事・スキル"
            },
            {
              catSmlCd: "303",
              catSmNm: "お子様"
            },
            {
              catSmlCd: "304",
              catSmNm: "ライフイベント"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他慶事お祝い"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "キャンペーン",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "キャンペーン"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "イベント・セミナー",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "イベント・セミナー"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "オリジナルコンテンツ",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "オリジナルコンテンツ"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "その他オリジナル企画",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "その他オリジナル企画"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "-",
      catExlNm: "検索対象外",
      catLrgCd: "117",
      catLrgNm: "ポイント交換",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "ポイント交換",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "募金"
            },
            {
              catSmlCd: "302",
              catSmNm: "提携サイト"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "skillup",
      catExlNm: "スキルアップ",
      catLrgCd: "107",
      catLrgNm: "スキルアップ",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "語学",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スクール"
            },
            {
              catSmlCd: "302",
              catSmNm: "教材・通信講座"
            },
            {
              catSmlCd: "303",
              catSmNm: "オンライン"
            },
            {
              catSmlCd: "304",
              catSmNm: "留学・その他"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "資格取得",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スクール"
            },
            {
              catSmlCd: "302",
              catSmNm: "オンライン・教材・通信講座"
            },
            {
              catSmlCd: "303",
              catSmNm: "検定"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "趣味・教養",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "趣味・教養"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "ビジネススキル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ビジネススキル"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "IT・パソコン",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "IT・パソコン"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "スキルアップ企画・制度",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "スキルアップ企画・制度"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "others",
      catExlNm: "その他",
      catLrgCd: "108",
      catLrgNm: "暮らし",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "家事",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "家事代行・ハウスクリーニング"
            },
            {
              catSmlCd: "302",
              catSmNm: "クリーニング・お直し"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "住まい",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "住宅購入"
            },
            {
              catSmlCd: "302",
              catSmNm: "賃貸住宅"
            },
            {
              catSmlCd: "303",
              catSmNm: "リフォーム・メンテナンス"
            },
            {
              catSmlCd: "304",
              catSmNm: "ガーデニング"
            },
            {
              catSmlCd: "305",
              catSmNm: "防犯・防災"
            },
            {
              catSmlCd: "306",
              catSmNm: "住宅関連セミナー"
            }
          ]
        },
        {
          catMidCd: "203",
          catMidNm: "カー",
          list: [
            {
              catSmlCd: "302",
              catSmNm: "カーシェア・カーリース"
            },
            {
              catSmlCd: "303",
              catSmNm: "駐車場"
            },
            {
              catSmlCd: "304",
              catSmNm: "ガソリンスタンド"
            },
            {
              catSmlCd: "305",
              catSmNm: "新車・中古車販売・買取"
            },
            {
              catSmlCd: "306",
              catSmNm: "タクシー・送迎サービス"
            },
            {
              catSmlCd: "307",
              catSmNm: "免許・教習所"
            },
            {
              catSmlCd: "308",
              catSmNm: "車検・修理・整備"
            },
            {
              catSmlCd: "309",
              catSmNm: "その他カー"
            }
          ]
        },
        {
          catMidCd: "204",
          catMidNm: "通信・電気・ガス",
          hidden: true,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "携帯電話"
            },
            {
              catSmlCd: "302",
              catSmNm: "Wifi・インターネット回線"
            },
            {
              catSmlCd: "303",
              catSmNm: "電気・ガス"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他通信・電気・ガス"
            }
          ]
        },
        {
          catMidCd: "205",
          catMidNm: "引越し",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "引越し"
            }
          ]
        },
        {
          catMidCd: "206",
          catMidNm: "リサイクル・レンタル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "リサイクル"
            },
            {
              catSmlCd: "302",
              catSmNm: "レンタルサービス"
            },
            {
              catSmlCd: "303",
              catSmNm: "買取"
            }
          ]
        },
        {
          catMidCd: "207",
          catMidNm: "ライフプラン設計",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "保険・金融・資産形成"
            },
            {
              catSmlCd: "302",
              catSmNm: "ふるさと納税"
            },
            {
              catSmlCd: "303",
              catSmNm: "終活"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他ライフプラン設計"
            }
          ]
        },
        {
          catMidCd: "208",
          catMidNm: "ペット",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "ペット"
            }
          ]
        },
        {
          catMidCd: "209",
          catMidNm: "写真・プリント",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "写真・プリント"
            }
          ]
        },
        {
          catMidCd: "210",
          catMidNm: "アクティブシニア",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "アクティブシニア"
            }
          ]
        },
        {
          catMidCd: "211",
          catMidNm: "相談・サポート",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "相談サービス"
            },
            {
              catSmlCd: "302",
              catSmNm: "トラブルサポート"
            }
          ]
        },
        {
          catMidCd: "212",
          catMidNm: "葬儀・葬祭",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "葬儀・葬祭"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "others",
      catExlNm: "その他",
      catLrgCd: "112",
      catLrgNm: "出会い・結婚",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "出会い",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚情報"
            },
            {
              catSmlCd: "302",
              catSmNm: "お見合いパーティ"
            },
            {
              catSmlCd: "303",
              catSmNm: "ネット婚活"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他出会い"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "ブライダル",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "結婚式"
            },
            {
              catSmlCd: "302",
              catSmNm: "リング"
            },
            {
              catSmlCd: "303",
              catSmNm: "ドレス"
            },
            {
              catSmlCd: "304",
              catSmNm: "ブライダルエステ"
            },
            {
              catSmlCd: "305",
              catSmNm: "その他ブライダル"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "care",
      catExlNm: "育児・介護・健康",
      catLrgCd: "110",
      catLrgNm: "介護",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "介護",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "在宅介護"
            },
            {
              catSmlCd: "302",
              catSmNm: "シニア住宅・介護施設"
            },
            {
              catSmlCd: "303",
              catSmNm: "介護用品"
            },
            {
              catSmlCd: "304",
              catSmNm: "見守りサービス"
            },
            {
              catSmlCd: "305",
              catSmNm: "介護タクシー"
            },
            {
              catSmlCd: "306",
              catSmNm: "宅配・宅食"
            },
            {
              catSmlCd: "307",
              catSmNm: "その他介護"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "介護補助金制度",
          hidden: true,
          list: [
            {
              catSmlCd: "301",
              catSmNm: "介護補助金制度"
            }
          ]
        }
      ]
    },
    {
      catExlCd: "care",
      catExlNm: "育児・介護・健康",
      catLrgCd: "111",
      catLrgNm: "健康",
      catType: 1,
      list: [
        {
          catMidCd: "201",
          catMidNm: "健康管理",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "眼科"
            },
            {
              catSmlCd: "302",
              catSmNm: "歯科"
            },
            {
              catSmlCd: "303",
              catSmNm: "美容医療"
            },
            {
              catSmlCd: "304",
              catSmNm: "その他健康管理"
            }
          ]
        },
        {
          catMidCd: "202",
          catMidNm: "健診・相談",
          list: [
            {
              catSmlCd: "301",
              catSmNm: "健診・郵送検診"
            },
            {
              catSmlCd: "302",
              catSmNm: "相談・カウンセリング"
            }
          ]
        }
      ]
    },
    // {
    //   catExlCd: "others",
    //   catExlNm: "その他",
    //   catLrgCd: "119",
    //   catLrgNm: "各種手続き・サポート",
    //   catType: 1,
    //   list: [
    //     {
    //       catMidCd: "201",
    //       catMidNm: "お問合せ",
    //       list: [
    //         {
    //           catSmlCd: "301",
    //           catSmNm: "お問合せ"
    //         }
    //       ]
    //     },
    //     {
    //       catMidCd: "202",
    //       catMidNm: "会員サポートサービス",
    //       list: [
    //         {
    //           catSmlCd: "301",
    //           catSmNm: "会員サポートサービス"
    //         }
    //       ]
    //     },
    //     {
    //       catMidCd: "203",
    //       catMidNm: "ガイドブック・会員証",
    //       hidden: true,
    //       list: [
    //         {
    //           catSmlCd: "301",
    //           catSmNm: "ガイドブック・会員証"
    //         }
    //       ]
    //     },
    //     {
    //       catMidCd: "204",
    //       catMidNm: "ID・PW再発行",
    //       hidden: true,
    //       list: [
    //         {
    //           catSmlCd: "301",
    //           catSmNm: "ID・PW再発行"
    //         }
    //       ]
    //     },
    //     {
    //       catMidCd: "205",
    //       catMidNm: "その他手続き",
    //       list: [
    //         {
    //           catSmlCd: "301",
    //           catSmNm: "その他手続き"
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
};
